import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class Invitation extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId }) {
        if (!eventId || !organizationId) {
            throw new ArgumentError(`[Invitation] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/invitation`;
    }

    create_invitations_async(params = {}, query = {}) {
        let data = this.toAPI();

        const newParams = {
            ...this.__params,
            ...params
        };

        delete newParams.metadata;

        if (!params.eventId || !params.organizationId) {
            throw new ArgumentError(`[Invitation] organizationId and eventId are mandatory`);
        }

        data = {
            type: 'async_create_invitations_light',
            config: { ...data['data'] }
        };

        const url = this.constructor.getListUrl(newParams);
        return this.constructor.fetcher.post(url, { ...params, data });
    }
}
